export default __webpack_public_path__ + "static/media/partnerRightPolygon.1b152372.svg";